module.exports = __webpack_public_path__ + "static/media/sg.279844e9.svg";